import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgPersonSearch({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 32 32"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M14.647 16.293a.667.667 0 0 0-.198-.993 9.844 9.844 0 0 0-4.836-1.293 10.063 10.063 0 0 0-9.585 7.147.667.667 0 0 0 .639.858h11.362a.667.667 0 0 0 .667-.622 9.273 9.273 0 0 1 1.951-5.098Z" />
            <circle cx={9.338} cy={6.337} r={6.337} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.2 25.944a.334.334 0 0 0 .045.415l3.38 3.38a1.334 1.334 0 0 1-1.886 1.887l-3.38-3.38a.334.334 0 0 0-.415-.046 7.349 7.349 0 1 1 2.256-2.256Zm-1.52-3.933a4.669 4.669 0 1 0-9.338 0 4.669 4.669 0 0 0 9.338 0Z"
            />
        </svg>
    )
}
SvgPersonSearch.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgPersonSearch
